import {createCartController} from './cart/controller';
import {assetUrl, copy} from './site.js';
import $ from "jquery";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function pdpInteractivity() {

    let lastClickedMobileAddToCart = null;
    let confirmedCart, adding = false;
    const controller = createCartController({
        render(result) { confirmedCart = result; },
        busy() {},
        message(message) { if (message) alert(copy(message)); }
    });

    $('.js-add-to-cart-mobile').on('click', function () {
        lastClickedMobileAddToCart = $(this);
        $('.product-detail-add-to-cart').submit();
    });

    $('.button-add-to-cart').on('click', function (e) {
        e.preventDefault();
        lastClickedMobileAddToCart = $(this);
        $('.product-detail-add-to-cart').submit();
    });

    $('.product-detail-add-to-cart').on('submit', async function (e) {
        e.preventDefault();

        const form = $(this);
        const product = parseInt(form.find('input[name="product"]').val(), 10);
        const quantity = parseInt(form.find('input[name="quantity"]').val(), 10);
        const desktopButton = form.find('button[type=submit]');

        lastClickedMobileAddToCart = lastClickedMobileAddToCart || desktopButton;
        lastClickedMobileAddToCart.addClass('adding');

        if (adding) return;
        adding = true;
        lastClickedMobileAddToCart = lastClickedMobileAddToCart || desktopButton;
        try {
            if (!await controller.mutate('add', {product, quantity})) return;
            const result = confirmedCart;
                lastClickedMobileAddToCart.removeClass('pulse');
                void lastClickedMobileAddToCart[0].offsetWidth;
                lastClickedMobileAddToCart.addClass('pulse').blur();
                setTimeout(() => lastClickedMobileAddToCart.removeClass('pulse'), 2000);

                const item = result.order.items.find(i => i.product === product);
                if (!item) return;

                const $popup = $('.cart-popup');
                const $list = $popup.find('.cart-popup-list');

                $list.find(`.cart-popup-item[data-product="${product}"]`).remove();

                const variantText = getVariantLabel();

                const html = `
                <div class="cart-popup-item" data-product="${item.product}">
                    <div class="cart-popup-main">
                        <figure>
                            <img src="${assetUrl(item.image)}" alt="${item.name}">
                        </figure>
                        <div class="cart-popup-details">
                            <div class="title">${item.name.trim()}</div>
                            ${variantText ? `<div class="variant">${variantText}</div>` : ''}
                        </div>
                    </div>
                    <div class="cart-popup-meta text-right">
                        <div class="price">${item.total_ex_tax_formatted.replace('€', '€ ')}</div>
                    </div>
                </div>
            `;

                $list.prepend(html);

                const total = result.order.total_formatted.replace('€', '€ ');
                let shipping = result.order.shipping_formatted.replace('€', '€ ');

                if (result.order.shipping === 0) {
                    shipping = copy('Free');
                }

                $popup.find('.cart-popup-summary .total .value').text(total);
                $popup.find('.cart-popup-summary .shipping .value').text(shipping);

                $('body').addClass('added-product')
        } finally {
            adding = false;
            lastClickedMobileAddToCart.removeClass('adding');
        }

        $(document).on('click', function (e) {
            const $popup = $('.cart-popup');

            if (!$popup.is(':visible')) return;

            const isInsidePopup = $(e.target).closest('.cart-popup').length > 0;
            const isCloseButton = $(e.target).closest('.cart-popup .main-title svg, .cart-popup .cart-popup-close svg').length > 0;

            if (!isInsidePopup || isCloseButton) {
                $('body').removeClass('added-product');
            }
        });

        function getVariantLabel() {
            const variants = [];

            $('.matrix-options .matrix-select').each(function () {
                const selected = $(this).find('.choices__item.is-highlighted').text().trim();
                if (selected) variants.push(selected);
            });

            return variants.join(' | ');
        }
    });


    const isMediumUp = Foundation.MediaQuery.atLeast('xlarge');
    const $stickyTarget = $('.js-sticky-target');

    if (isMediumUp) {
        $stickyTarget.each(function () {
            const $this = $(this);
            $this.attr({
                'data-sticky': '',
                'data-anchor': 'product-detail',
                'data-margin-top': '0'
            });

            new Foundation.Sticky($this, {});
        });
    } else {
        $stickyTarget.addClass('is-sticky-bottom');
    }

    const rowSelect = document.querySelector('#matrix-select-row');
    const colSelect = document.querySelector('#matrix-select-column');
    const options = document.querySelectorAll('.matrix-option');
    const galleries = document.querySelectorAll('.product-gallery');

    function updateGallery() {
        const rowId = rowSelect?.value ?? '';
        const colId = colSelect?.value ?? '';

        let selector = '';
        if (rowId && colId) {
            selector = `#product-option-${rowId}-${colId}`;
        } else if (rowId) {
            selector = `.matrix-option[id^="product-option-${rowId}-"]`;
        } else if (colId) {
            selector = `.matrix-option[id$="-${colId}"]`;
        } else {
            return;
        }

        const option = document.querySelector(selector);
        if (!option) return;

        const productId = option.dataset.productId;
        const targetGallery = document.querySelector(`#gallery-for-${productId}`);

        // Update gallery
        galleries.forEach(gallery => {
            if (gallery === targetGallery) {
                gallery.style.display = 'block';
            } else {
                gallery.style.display = 'none';
            }

            const imgs = gallery.querySelectorAll('img');
            imgs.forEach(img => {
                img.style.opacity = gallery === targetGallery ? '1' : '0';
                img.style.visibility = gallery === targetGallery ? 'visible' : 'hidden';
            });
        });

        // Update price
        const format = (cents) => (cents / 100).toFixed(2).replace('.', ',');

        const priceEl = document.querySelector('.buying-price');
        const regularPriceEl = document.querySelector('.pricing-before');

        const price = option.dataset.price;
        const regularPrice = option.dataset.regularPrice;

        if (priceEl) {
            priceEl.textContent = isNaN(price) ? copy('Login') : format(parseInt(price, 10));
        }

        if (regularPriceEl && price < regularPrice) {
            regularPriceEl.textContent = format(regularPrice);
        } else if (regularPriceEl) {
            regularPriceEl.textContent = '';
        }

        // Update stock status and Add to cart button
        const stock = option.dataset.stock > 0;
        const stockStatus = document.querySelector('.stock-status');
        const stockText = stockStatus?.querySelector('span');
        const addToCartBtn = document.querySelector('.button-add-to-cart');

        if (stockStatus && stockText && addToCartBtn) {
            if (stock) {
                stockStatus.classList.remove('out-of-stock');
                stockText.textContent = copy('In stock');
                addToCartBtn.disabled = false;
            } else {
                stockStatus.classList.add('out-of-stock');
                stockText.textContent = copy('Out of stock');
                addToCartBtn.disabled = true;
            }
        }

        const productInput = document.querySelector('#selected-product-id');
        if (productInput && option?.dataset.productId) {
            productInput.value = option.dataset.productId;
        }

    }

    if (rowSelect) rowSelect.addEventListener('change', updateGallery);
    if (colSelect) colSelect.addEventListener('change', updateGallery);


    document.querySelectorAll('.product-link').forEach(link => {
        link.addEventListener('click', function (e) {
            const productId = this.dataset.productId;
            const url = this.href;
            if (!productId) return;

            e.preventDefault();

            fetch('/set-matrix', {
                method: 'POST',
                body: new URLSearchParams({ id: productId }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                keepalive: true
            }).finally(() => {
                window.location.href = url;
            });
        });
    });

    gsap.registerPlugin(ScrollTrigger);

    const mobileBar = document.querySelector('.product-info-mobile');
    const rightSide = document.querySelector('.product-detail-right');

    if (mobileBar && rightSide) {
        gsap.set(mobileBar, { autoAlpha: 1, y: 0 });

        ScrollTrigger.create({
            trigger: rightSide,
            start: 'top bottom-=0',
            end: 'top bottom',
            onEnter: () => {
                const tl = gsap.timeline({ overwrite: true });
                tl.to(mobileBar, {
                    y: 20,
                    duration: 0.2,
                    ease: 'power1.out'
                }, 0)
                    .to(mobileBar, {
                        autoAlpha: 0,
                        duration: 0.3,
                        ease: 'power2.out'
                    }, 0);
            },
            onLeaveBack: () => {
                const tl = gsap.timeline({ overwrite: true });
                tl.to(mobileBar, {
                    y: 0,
                    duration: 0.2,
                    ease: 'power1.out'
                }, 0)
                    .to(mobileBar, {
                        autoAlpha: 1,
                        duration: 0.3,
                        ease: 'power2.out'
                    }, 0);
            }
        });
    }


}
